var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStore = function SvgStore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 50 50"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.667,
    d: "M6.25 43.75h37.5M6.25 14.583v2.084a6.25 6.25 0 0 0 12.5 0m-12.5-2.084h37.5m-37.5 0 4.167-8.333h29.166l4.167 8.333m-25 2.084v-2.084m0 2.084a6.25 6.25 0 0 0 12.5 0m0 0v-2.084m0 2.084a6.25 6.25 0 0 0 12.5 0v-2.084M10.417 43.75V22.604M39.583 43.75V22.604M18.75 43.75v-8.333a4.167 4.167 0 0 1 4.167-4.167h4.166a4.167 4.167 0 0 1 4.167 4.167v8.333"
  })));
};
export default SvgStore;